import React, { useEffect, useMemo, useState } from "react";
import Navbar from "../../components/Enrollment/Navbar";
import "../../utils/Style/pages/enrollment.scss";
import "../../utils/Style/pages/OwnerShipProfile.scss";
import FormsTemplate from "./FormsTemplate";
import Stepper from "../../components/Enrollment/Stepper";
import MerchantFormsTemplate from "./MerchantFormsTemplate";
import { useNavigate, useParams } from "react-router-dom";
import useLogout from "../../api/logoutApi";
import ValidationPopup from "../../components/ValidationPopup";
import ValidationPopupMobile from "../../components/ValidationPopupMobile";
import MerchantEnrollmentAPI from "../../api/MerchantEnrollmentAPI";
import { useSelector } from "react-redux";

// here: function Enrollment({ entityh }) {
function Enrollment({ entity }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [render, setRerender] = useState(0);

  const {
    PerformAction,
    CorporateAutoFillData,
    GetCountries,
    GenerateSASuri,
    GetCorporateFlowId,
  } = MerchantEnrollmentAPI();
  //here:
  // let entity = "legal";

  useEffect(() => {
    if (entity === "legal") {
      (async () => {
        try {
          const code = sessionStorage.getItem("RegCodUrl");
          const { flowid, remoteId } = await GetCorporateFlowId();
           await PerformAction(code, remoteId, flowid);
           const { remoteID, verificationRef } = await CorporateAutoFillData();
          await GetCountries(code);
          await GenerateSASuri();
        } catch (err) {
          console.error("Enrollment effect failed:", err);
        }
      })();
    }
  }, [entity]);

  const stepsRedux = useSelector(
    (state) => state?.legalEnrollment?.performcorporateaction?.steps
  );

  useEffect(() => {
    if (!render) return;
    const targetStep =
      stepsRedux?.find((s) => s?.stepID === render)?.index || 1;

    setVisited([0]);
    setCurrentStep(targetStep);
    navigate(url + targetStep);
  }, [render, stepsRedux]);

  const totalSteps =
    entity === "legal" && stepsRedux?.length ? stepsRedux?.length : 6;
  const [visited, setVisited] = useState([0]);

  const { logout } = useLogout();
  const url = entity === "legal" ? "/enrollment/" : "/merchant-enrollment/";

  useEffect(() => {
    if (!sessionStorage.getItem("SessionID")) {
      logout();
    }
  }, []);

  const STEP_TITLES_BY_ID = {};

  const legalStepsFromRedux = useMemo(() => {
    if (!Array.isArray(stepsRedux) || stepsRedux.length === 0) return null;

    return stepsRedux
      .slice()
      .sort((a, b) => (a?.index ?? 0) - (b?.index ?? 0))
      .map((s, i) => {
        const stepNumber = s?.index ?? i + 1;
        const fallbackTitle =
          STEP_TITLES_BY_ID[s?.stepID] || `Step ${stepNumber}`;
        const desc =
          s?.description && s.description.trim()
            ? s.description
            : fallbackTitle;

        return { step: stepNumber, description: desc };
      });
  }, [stepsRedux]);

  const consumerSteps = [
    { step: 1, description: "Merchant Information" },
    { step: 2, description: "Merchant Profile" },
    { step: 3, description: "Payment Information" },
    { step: 4, description: "Admin" },
    { step: 5, description: "Done" },
  ];

  const steps =
    entity === "legal" && legalStepsFromRedux
      ? legalStepsFromRedux
      : consumerSteps;

  const { step } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (parseInt(step) === totalSteps) {
      setVisited([...visited, parseInt(step) - 1]);
    }

    if (step && visited.includes(parseInt(step) - 1)) {
      setCurrentStep(parseInt(step));
    } else if (visited.includes(totalSteps - 1)) {
      setCurrentStep(totalSteps);
    } else {
      navigate(url + currentStep);
    }
  }, [step]);

  const handleNext = () => {
    if (currentStep < totalSteps) {
      navigate(url + (currentStep + 1));
      setCurrentStep(currentStep + 1);
    }
  };

  return (
    <div className="enrollment">
      <Navbar />
      {currentStep !== totalSteps && (
        <Stepper
          currentStep={currentStep}
          steps={steps}
          setSteps={setCurrentStep}
          setCurrentStep={setCurrentStep}
          visited={visited}
          setVisited={setVisited}
        />
      )}
      {entity === "legal" && (
        <FormsTemplate
          key={render}
          handleNext={handleNext}
          currentStep={currentStep}
          setRerender={setRerender}
        />
      )}
      {entity === "merchant" && (
        <MerchantFormsTemplate
          handleNext={handleNext}
          currentStep={currentStep}
        />
      )}
      <ValidationPopup onOpenQrAfterGenerate={() => {}} />
      <ValidationPopupMobile />
    </div>
  );
}

export default Enrollment;
